import React from "react";

const renderMarkdown = (markdownText) => {
   // Split the Markdown content into lines
   if (!markdownText) return "";
   const lines = markdownText.split("\n");

   // Process each line and create React elements
   const elements = lines.map((line, index) => {
      const isLastIndex = index === lines.length - 1;
      if (line.startsWith("###")) {
         // Render headers with strong tag
         return (
            <h3 key={index} style={{ marginBottom: !isLastIndex && "20px" }}>
               <strong>{line.substring(4)}</strong>
            </h3>
         );
      } else if (line.startsWith("**")) {
         // Render bold list items with proper indentation
         const listItemText = line.substring(2).replace("**", ""); // Remove the double asterisks
         return (
            <li key={index} style={{ marginLeft: "20px", marginBottom: !isLastIndex && "20px" }}>
               {listItemText.split(":").map((s, i) => {
                  return i === 0 ? <strong>{s + " : "}</strong> : s;
               })}
            </li>
         );
      } else {
         // Render paragraphs without strong tag
         return (
            <p key={index} style={{ marginBottom: !isLastIndex && "20px" }}>
               {line}
            </p>
         );
      }
   });

   // Return the assembled React elements
   return elements;
};

const DictationRenderer = ({ content }) => {
   return <div style={{ fontSize: "17px", paddingRight: "10px" }}>{renderMarkdown(content)}</div>;
};

export default DictationRenderer;
